/**
 * Whether Gemini Live (beta) appears as an STT choice (Encounter + Translation toggles).
 * On by default for ChartMind trials; set REACT_APP_CHARTMIND_GEMINI_LIVE_STT_UI_DISABLED=true to hide.
 *
 * Local dev / REACT_APP_CHARTMIND_GEMINI_LIVE_DEV_UNGATED=true ignores STT_UI_DISABLED
 * (see chartmindGeminiLiveDevTrialMode).
 */

import { isChartMindGeminiLiveUngatedForTrials } from '../translation/chartmindGeminiLiveDevTrialMode';

export const isChartMindGeminiLiveSttOptionEnabled = () => {
  if (isChartMindGeminiLiveUngatedForTrials()) return true;
  if (typeof process !== 'undefined' && process.env.REACT_APP_CHARTMIND_GEMINI_LIVE_STT_UI_DISABLED === 'true') {
    return false;
  }
  return true;
};
